<template>
  <FilteringFacetsHorizontalFacets
    v-if="selectedCriteriaOptions.length > 0"
    class="margin-top-xs"
    name="facet-chip"
    facet-style="chip"
    :options="selectedCriteriaOptions"
    @on-facet-click="selectedCriteriaFacetClick"
  />
</template>

<script setup>
const filteringFacetsStore = useFilteringFacetsStore();

const facets = computed(() => filteringFacetsStore.getFacets);
const getSelectedSortOrder = (value) => {
  const isPriceCategory = value.category.toLowerCase() === 'price';
  return isPriceCategory ? parseInt(value.id.replace(/$|\|.*/, ''), 10) : value.id;
};

const selectedCriteriaOptions = computed(() =>
  facets.value
    .filter((facet) => facet.selectedValues.length > 0)
    .map((facet) =>
      facet.selectedValues
        .map((selected) => {
          const displayName = facet.values.filter((value) => value.value === selected)[0].label;
          return {
            id: `${selected}`,
            closeable: true,
            contents: { text: displayName.replace(/\s*\(\d+\)$/, '') },
            category: facet.name,
          };
        })
        .sort((a, b) => {
          const aSortValue = getSelectedSortOrder(a);
          const bSortValue = getSelectedSortOrder(b);
          if (aSortValue > bSortValue) {
            return 1;
          }

          if (aSortValue < bSortValue) {
            return -1;
          }

          return 0;
        }),
    )
    .flat(),
);

const selectedCriteriaFacetClick = (facet) => {
  const { category } = facet.selected;
  const selectedChip = facet.selected.id;
  filteringFacetsStore.replaceSelectedValues({
    name: category,
    selectedValues: filteringFacetsStore.getFacetByName(category).selectedValues.filter((value) => value !== selectedChip),
  });
  if (category === 'Price' && facet.selected.contents.text.indexOf('Custom') === 0) {
    filteringFacetsStore.removeCheckboxValuesByValue({
      name: category,
      value: selectedChip,
    });
  }
  filteringFacetsStore.getAllSelectedCriteria();
};
</script>
